import { Radio } from "antd";

export default function TabSelector({
  value,
  disabled,
  onChange,
  options,
  defaultValue,
}: {
  value?: string;
  disabled?: boolean;
  onChange?: (v) => void;
  options;
  defaultValue?: string;
}) {
  return (
    <Radio.Group
      value={value}
      defaultValue={defaultValue}
      style={{ width: "100%" }}
      buttonStyle="solid"
      className="audioModalTab"
      disabled={disabled}
      onChange={(v) => onChange?.(v.target.value)}
    >
      {options.map((item) => {
        return (
          <Radio.Button
            key={item.value}
            value={item.value}
            className="audioModalTabButton"
            style={{ width: `${100 / options.length}%` }}
          >
            {item.label}
          </Radio.Button>
        );
      })}
    </Radio.Group>
  );
}
